// frontend/admin-portal/src/components/treasury/TreasuryStats.jsx
import React, { useEffect, useState } from "react";
import { Card, Title, Spinner, formatMoney } from "@fiberhome/shared-ui";
import { treasuryService } from "../../services/treasuryService";
import { useSettings } from "../../contexts/SettingsContext";

export default function TreasuryStats({ refreshKey = 0 }) {
  const { get } = useSettings();
  const settingsCurrency = get(
    "finance.baseCurrency",
    get("finance.currencySymbol", "IQD"),
  );

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    treasuryService
      .dashboard()
      .then((d) => alive && setData(d))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  // Backend's baseCurrency wins (it also honors settings), settings as fallback
  const currency = data?.baseCurrency || settingsCurrency || "IQD";

  const cards = [
    {
      label: `Cash on Hand (${currency})`,
      value: data ? formatMoney(data.totalBalance, { symbol: currency }) : "—",
      color: "var(--fh-primary)",
    },
    {
      label: `Inventory Value (${currency})`,
      value: data
        ? formatMoney(data.inventoryValue, { symbol: currency })
        : "—",
      color: "var(--fh-info)",
    },
    {
      label: `Total Assets (${currency})`,
      value: data ? formatMoney(data.totalAssets, { symbol: currency }) : "—",
      color: "var(--fh-success)",
    },
    {
      label: `This Month · Net (${currency})`,
      value: data ? formatMoney(data.month?.net, { symbol: currency }) : "—",
      color:
        (data?.month?.net || 0) >= 0 ? "var(--fh-success)" : "var(--fh-danger)",
    },
  ];

  return (
    <div className="row g-3 mb-4">
      {cards.map((c) => (
        <div className="col-md-3 col-sm-6" key={c.label}>
          <Card hoverable>
            <div className="text-muted" style={{ fontSize: 12 }}>
              {c.label}
            </div>
            <Title
              level={3}
              className="mb-0"
              style={{ color: c.color, fontSize: 20 }}
            >
              {loading ? <Spinner size="md" /> : c.value}
            </Title>
          </Card>
        </div>
      ))}
    </div>
  );
}
